import type {
  InputMaybe,
  Lead_Agents_Bool_Exp,
  Leads_Bool_Exp,
} from '@graphql/__generated__/graphql';

type ComparisonExp = { _eq?: string | null; _in?: string[] | null } | null;

const extractFilterValues = (
  where: InputMaybe<Leads_Bool_Exp> | undefined,
  accessors: ((agents: Lead_Agents_Bool_Exp) => ComparisonExp | undefined)[],
) => {
  const resolve = (agents: Lead_Agents_Bool_Exp | undefined) =>
    agents == null
      ? undefined
      : accessors.reduce<ComparisonExp | undefined>(
          (acc, fn) => acc ?? fn(agents),
          undefined,
        );

  let match = resolve(where?.lead_agents ?? undefined);

  if (match == null) {
    const clause = where?._and?.find(
      item => resolve(item.lead_agents ?? undefined) != null,
    );
    match = resolve(clause?.lead_agents ?? undefined);
  }

  if (match?._eq != null) {
    return [match._eq];
  }
  if (match?._in != null) {
    return match._in;
  }
  return null;
};

export const extractSelectedStagesWhere = (
  where: InputMaybe<Leads_Bool_Exp> | undefined,
) =>
  extractFilterValues(where, [
    agents => agents.stage_id,
    agents => agents.lead_stage?.id,
  ]);

export const extractSelectedAgentsWhere = (
  where: InputMaybe<Leads_Bool_Exp> | undefined,
) =>
  extractFilterValues(where, [
    agents => agents.user_id,
    agents => agents.user?.id,
  ]);
